module.exports = __webpack_public_path__ + "img/album14_05.8d335587.jpg";